import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthComponent } from './auth.component';
import { RouteOverviewComponent } from '../route-overview/route-overview.component';
import { NewRouteComponent } from '../new-route/new-route.component';
import { RouteDetailComponent } from '../route-detail/route-detail.component';
import { ProjectOverviewComponent } from '../project-overview/project-overview.component';
import { DashboardOverviewComponent } from '../dashboard-overview/dashboard-overview.component';

const authRoutes: Routes = [
    {
        path: 'auth',
        component: AuthComponent,
        children: [
            {
                path: '', component: RouteOverviewComponent
            },
            {
                path: 'projects', component: ProjectOverviewComponent
            },
            {
                path: 'dashboards', component: DashboardOverviewComponent
            },
            {
                path: 'new-route', component: NewRouteComponent
            },
            {
                path: 'new-route/:projectId', component: NewRouteComponent
            },
            {
                path: 'copy-route/:jobId', component: NewRouteComponent
            },
            {
                path: 'edit-route/:jobId', component: NewRouteComponent
            },
            {
                path: 'copy-route/:jobId/:projectId', component: NewRouteComponent
            },
            {
                path: 'route-detail/:routeId', component: RouteDetailComponent
            },
            {
                path: 'route-detail/:routeId/:projectId', component: RouteDetailComponent
            }
        ]
    }
];
export const authRouting: ModuleWithProviders = RouterModule.forChild(authRoutes);



// WEBPACK FOOTER //
// ./src/app/modules/auth/auth.routing.ts